import { Reveal, Overline } from "../components/motion";
import { NEWS } from "../data/content";

export default function NewsPage() {
  return (
    <main className="pt-20">
      <section className="py-20 md:py-28 bg-navy text-primary-foreground">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Overline light>College Journal</Overline>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl tracking-tight leading-[1.05]">
            News & <span className="italic text-gold">stories</span>
          </h1>
          <p className="mt-6 max-w-2xl text-primary-foreground/60 leading-relaxed">
            Important dates, events, course information, and life at the college —
            follow our official journal.
          </p>
        </div>
      </section>

      <section className="py-24 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {NEWS.map((a, i) => (
            <Reveal key={a.id} delay={(i % 3) * 0.08} className={i === 0 ? "md:col-span-2 lg:col-span-2" : ""}>
              <article data-testid={`news-article-${a.id}`} className="group cursor-pointer">
                <div className={`overflow-hidden rounded-sm ${i === 0 ? "aspect-[16/8]" : "aspect-[4/3]"}`}>
                  <img
                    src={a.image}
                    alt={a.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                  />
                </div>
                <div className="mt-6 flex items-center gap-4">
                  <span className="text-xs tracking-[0.2em] uppercase text-accent">{a.category}</span>
                  <span className="h-px w-6 bg-border" />
                  <span className="text-xs text-muted-foreground">by {a.author}</span>
                </div>
                <h2 className={`mt-3 font-serif leading-snug text-navy transition-colors duration-300 group-hover:text-accent ${i === 0 ? "text-3xl md:text-4xl" : "text-2xl"}`}>
                  {a.title}
                </h2>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{a.excerpt}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
